import React from 'react';
import classNames from 'classnames';
import RenderStaticHTML from '../RenderStaticHTML';

const ns = `pdp-supplement-facts`;

const PDPSupplementFacts = ({ supplementFacts }) => {
	const rootClassnames = classNames({
		[`${ ns }`]: true,
		[`container`]: true,
	});

	return (
		<div className={rootClassnames}>
			<RenderStaticHTML
				className={'wysiwyg'}
				html={supplementFacts?.value}
			/>
		</div>
	);
};

export default PDPSupplementFacts;
